export interface DurableLogConfig {
  enabled: boolean;
  segmentFlushBytes: number;
  segmentFlushDurationMs: number;
  segmentFlushIntervalMs: number;
  maxPendingBytes: number;
  replayOverlapMs: number;
  replayMode: "hard" | "balanced";
  replayBatchMaxBytes: number;
  replayBatchMaxSegments: number;
  mildStallMs: number;
  strongStallMs: number;
  partialStabilityMinCount: number;
  partialStabilityMinMs: number;
  diagnosticsLimit: number;
  chunkIndexEnabled: boolean;
}

export const DEFAULT_DURABLE_LOG_CONFIG: DurableLogConfig = {
  enabled: false,
  segmentFlushBytes: 262144,
  segmentFlushDurationMs: 2000,
  segmentFlushIntervalMs: 1000,
  maxPendingBytes: 524288,
  replayOverlapMs: 500,
  replayMode: "hard",
  replayBatchMaxBytes: 524288,
  replayBatchMaxSegments: 8,
  mildStallMs: 2000,
  strongStallMs: 4000,
  partialStabilityMinCount: 2,
  partialStabilityMinMs: 600,
  diagnosticsLimit: 500,
  chunkIndexEnabled: false,
};

export const resolveDurableLogConfig = (
  config?: Partial<DurableLogConfig>
): DurableLogConfig => ({
  ...DEFAULT_DURABLE_LOG_CONFIG,
  ...config,
});
